import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { animationWrapper, revealUp, slideLeft } from './onboarding-banner-animations';

@Component({
  selector: 'lp2-onboarding-banner',
  templateUrl: './onboarding-banner.component.html',
  styleUrls: ['./onboarding-banner.component.scss'],
  animations: [animationWrapper, slideLeft, revealUp],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnboardingBannerComponent {
  @Input() backgroundColor: string;
  constructor() { }
}



// WEBPACK FOOTER //
// ./ts/app/home/onboarding-banner/onboarding-banner.component.ts